import { render, staticRenderFns } from "./ChangelogDialog.vue?vue&type=template&id=7b50df8c"
import script from "./ChangelogDialog.vue?vue&type=script&lang=js"
export * from "./ChangelogDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports